import React, { useState, useEffect, useMemo } from 'react';
import apiClient from '../utils/apiClient';
import { useTable, usePagination, useGlobalFilter, useSortBy } from 'react-table';
import Swal from 'sweetalert2';
import { SERVER_BASE } from '../config/server';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV, faEdit, faTrash, faPlus, faPencil } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';
const DepartmentPage = ({ permissions }) => {

  const [departments, setDepartments] = useState([]);
  const [departmentName, setDepartmentName] = useState('');
  const [departmentalGroupCode, setDepartmentalGroupCode] = useState('');
  const [editIndex, setEditIndex] = useState(null);
  const token = localStorage.getItem('token');
  // Retrieve 'code' from session storage
  const code = localStorage.getItem('code');
  const role = localStorage.getItem('role')
  const [loadingDepartments, setLoadingDepartments] = useState(true);
  const email = localStorage.getItem('email');

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      setLoadingDepartments(true);
      const token = localStorage.getItem('token');
      if (!token) {
        console.error('Unauthorized: No token found.');
        setLoadingDepartments(false);
        return;
      }
      const response = await apiClient.get(SERVER_BASE + '/departments', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { code },
      });
      setDepartments(response.data);
    } catch (error) {
      console.error('Error fetching departments:', error);
    } finally {
      setLoadingDepartments(false);
    }
  };


  const handleDepartmentChange = (e) => setDepartmentName(e.target.value);
  const handleDepartmentCodeChange = (e) => setDepartmentalGroupCode(e.target.value);
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (departmentName.trim() === '') {
      Swal.fire('Please enter a department name', '', 'warning');
      return;
    }

    Swal.fire({
      title: editIndex !== null ? 'Confirm Update' : 'Confirm Create',
      text: editIndex !== null ? 'Are you sure you want to update this department?' : 'Are you sure you want to create this department?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const token = localStorage.getItem('token'); // Retrieve token from localStorage

        if (!token) {
          Swal.fire('Unauthorized: No token found.', '', 'error');
          return;
        }

        try {
          let responseMessage = ''; // Variable to hold response message

          if (editIndex !== null) {
            // Update department
            const response = await apiClient.put(
              `${SERVER_BASE}/updateDepartments/${departments[editIndex].id}`,
              {
                name: departmentName,
                departmentalGroupCode,
                email,
                code, // Include 'code' in the update
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`, // Add the JWT token in the header
                },
              }
            );
            responseMessage = response.data.message || 'Department updated successfully'; // Get response message from backend
          } else {
            // Create department
            const response = await apiClient.post(
              SERVER_BASE + '/addDepartments',
              {
                name: departmentName,
                departmentalGroupCode,
                email,
                code, // Include 'code' in the creation
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`, // Add the JWT token in the header
                },
              }
            );
            responseMessage = response.data.message || 'Department created successfully'; // Get response message from backend
          }

          setDepartmentName('');
          setDepartmentalGroupCode('')
          setEditIndex(null);
          fetchDepartments();

          // Show success message with the backend response
          Swal.fire({
            icon: 'success',
            title: editIndex !== null ? 'Updated!' : 'Created!',
            text: responseMessage,
            position: 'top-end', // Position at the top-end of the screen
            toast: true, // Display as toast
            timer: 2000,
            showConfirmButton: false // Show for 3 seconds
          });
        } catch (error) {
          console.error('Error saving department:', error);

          // Show error message if something went wrong
          Swal.fire({
            icon: 'error',
            // title: 'Error!',
            text: error.response?.data || 'There was an error processing your request.',
            position: 'top-end', // Position at the top-end of the screen
            toast: true, // Display as toast
            timer: 2000,
            showConfirmButton: false // Show for 3 seconds // Show for 3 seconds
          });
        }
      }
    });
  };


  const handleEdit = (index) => {
    setDepartmentName(departments[index].name);
    setDepartmentalGroupCode(departments[index].departmentalGroupCode)
    setEditIndex(index);
  };

  const handleDelete = async (index) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this department!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await apiClient.delete(
            `${SERVER_BASE}/deleteDepartments/${departments[index].id}`,
            {
              headers: {
                'Authorization': `Bearer ${token}`, // JWT token
              },
              data: { code }, // send centerCode
            }
          );

          // ✅ success message from server
          Swal.fire('Deleted!', response.data.message, 'success');
          fetchDepartments();
        } catch (error) {
          console.error('Error deleting department:', error);

          // ✅ check if backend sent custom error message
          const errorMessage =
            error.response?.data?.message || 'Error deleting department';

          Swal.fire('Cannot Delete', errorMessage, 'error');
        }
      }
    });
  };


  const columns = useMemo(
    () => [
      {
        Header: 'S.No',
        Cell: ({ row }) => row.index + 1,
      },
      {
        Header: 'Department Name',
        accessor: 'name',
      },
      {
        Header: 'Departmental Group Code',
        accessor: 'departmentalGroupCode',
      },
      {
        Header: "#",
        accessor: "Action",
        Cell: ({ row }) => {
          const {
            createdAt,
            createdByName,
            updatedAt,
            updatedByName,
          } = row.original;
          return (
            <div className="dropdown">
              <button
                className="btn btn-sm btn-light "
                type="button"
                id={`dropdownMenuButton-${row.index}`}
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <FontAwesomeIcon icon={faEllipsisV} />
              </button>

              <ul
                className="dropdown-menu"
                aria-labelledby={`dropdownMenuButton-${row.index}`}
              >
                {(role === "itManager" || permissions?.edit) && (
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleEdit(row.index)}
                    >
                      <FontAwesomeIcon icon={faEdit} className="me-2" />
                      Edit
                    </button>
                  </li>
                )}

                {(role === "itManager" || permissions?.delete) && (
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleDelete(row.index)}
                    >
                      <FontAwesomeIcon icon={faTrash} className="me-2" />
                      Delete
                    </button>
                  </li>
                )}
                {(createdByName || updatedByName) && (
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                )}
                {createdByName && (
                  <li className="dropdown-item">
                    <FontAwesomeIcon icon={faPlus} /> {createdByName}
                    {createdAt &&
                      ` (${moment(createdAt).format("DD-MMM-YY hh:mm A")})`}
                  </li>
                )}

                {/* Updated Info */}
                {updatedByName && (
                  <li className="dropdown-item">
                    <FontAwesomeIcon icon={faPencil} /> {updatedByName}
                    {updatedAt &&
                      ` (${moment(updatedAt).format("DD-MMM-YY hh:mm A")})`}
                  </li>
                )}
              </ul>
            </div>
          );
        },
      }
    ],
    [departments]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    setGlobalFilter,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize, globalFilter },
  } = useTable(
    {
      columns,
      data: departments,
      initialState: { pageIndex: 0, pageSize: 20 }, // min-20 page size
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  if (loadingDepartments) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '60vh' }}>
        <div className="spinner-border text-success" role="status" style={{ width: '3rem', height: '3rem' }}>
          <span className="visually-hidden">Loading...</span>
        </div>
        <div className="mt-3 fs-5">Please wait...</div>
      </div>
    );
  }

  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Department</h3>
        <div className="ledger-count">
          Total Departments: <strong>{departments.length}</strong>
        </div>
      </div>
      {(role == 'itManager' || permissions?.write) && (
        <>
          <form onSubmit={handleSubmit} className="formcontainer mb-3">
            <div className="row align-items-end">
              <div className="form-group col-md-3">
                <label htmlFor="departmentName">Department Name</label>
                <input
                  type="text"
                  id="departmentName"
                  className="form-control"
                  value={departmentName}
                  onChange={handleDepartmentChange}
                  placeholder="Enter Department Name"
                />
              </div>
              <div className="form-group col-md-3">
                <label htmlFor="departmentName">Departmental Group Code</label>
                <input
                  type="text"
                  id="departmentalGroupCode"
                  className="form-control"
                  value={departmentalGroupCode}
                  onChange={handleDepartmentCodeChange}
                  placeholder="Departmental Group Code"
                />
              </div>
              <div className="col-md-2">
                <button type="submit" className="btn btn-outline-success w-100">
                  {editIndex !== null ? 'Update Department' : 'Add Department'}
                </button>
              </div>
            </div>
          </form>
        </>
      )}
      {(role == 'itManager' || permissions?.read || permissions?.write || permissions?.delete) && (
        <div className="formcontainer table-responsive">
          <div className="d-flex justify-content-between gap-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search departments"
              value={globalFilter || ''}
              onChange={(e) => setGlobalFilter(e.target.value)}
            />
            <label className="d-inline-flex align-items-center ">
              <select
                value={pageSize}
                onChange={(e) => setPageSize(Number(e.target.value))}
                className="form-select form-select w-auto"
              >
                {[20, 30, 50, 100].map((size) => (
                  <option key={size} value={size}>
                    Show {size}
                  </option>
                ))}
              </select>

            </label>
          </div>

          <table {...getTableProps()} className="table table-striped" style={{ fontSize: '14px', marginTop: '11px' }}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                      {column.render('Header')}
                      <span>{column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}</span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => (
                      <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>

          <div className="d-flex align-items-center mb-3">
            {/* Previous – left corner */}
            <button
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
              className="btn btn-secondary me-auto"
              style={{ minWidth: 110 }}   // keeps width consistent
            >
              Previous
            </button>

            {/* Center block for page index & size selector */}
            <div className="text-center flex-grow-1 d-flex flex-column align-items-center">
              {/* Row 1: Page index and size selector in one line */}
              <div className="d-flex align-items-center gap-3">
                <div className="fw-semibold">
                  Page {pageIndex + 1} of {pageOptions.length}
                </div>


              </div>
            </div>


            {/* Next – right corner */}
            <button
              onClick={() => nextPage()}
              disabled={!canNextPage}
              className="btn btn-secondary ms-auto"
              style={{ minWidth: 110 }}
            >
              Next
            </button>
          </div>

        </div>
      )}
    </div>
  );
};

export default DepartmentPage;
